export default {
  proclamations: 'capricorn/proc-form',
  banks: 'capricorn/setup/banks',
  businessSources: 'capricorn/setup/businessSources',
  customers: 'capricorn/setup/customers',
  attachments: 'capricorn/proc-form/attachment',
  attachmentTypes: 'capricorn/setup/attachmentTypes',
  assetLocations: 'capricorn/setup/assetLocations'
}
